<template>
  <div class="relative z-[100]" :aria-labelledby="title" role="dialog" v-if="isOpen">

    <div class="fixed inset-0 z-[100] bg-gray-500 bg-opacity-75 transition-opacity"></div>

    <div class="fixed inset-0 z-[101] flex items-end justify-center overflow-y-auto p-4 text-center sm:items-center sm:p-0">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Modal Title'
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>


